import { useRef, useState } from "react";

export default function Header({
  filter,
  search,
  nse,
  nse_cash,
  options,
  mcx,
  mcx_options,
  comex,
  forex,
  crypto,
  us_stock,
  sgx,
  index,
  dgcx,
  ncdex,
}) {
  const searchRef = useRef();

  const [selectValue, setSelectValue] = useState(null);
  const [searchTerm, setSearch] = useState("");

  const statCard = (label, select, onClick) => {
    return (
      <div
        onClick={() => {
          onClick(select);
          setSelectValue(select);
        }}
        className={select === selectValue ? buttonStyle : buttonStyleDe}
        style={{ marginLeft: 5 }}
      >
        {label}
      </div>
    );
  };

  const buttonStyle =
    "relative flex items-center font-semibold bg-[var(--primary)] gap-1 px-2 py-1 text-xs uppercase rounded-md transition-all duration-300 border-2 text-white border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)] cursor-pointer";

  const buttonStyleDe =
    "relative flex items-center font-semibold bg-[var(--background)] gap-1 px-2 py-1 text-xs uppercase rounded-md transition-all duration-300 border-2 text-[var(--text)] border-[var(--hover)] hover:border-[var(--primary)]";

  return (
    <header
      style={{
        backgroundColor: "var(--background)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        height: "60px",
        borderBottom: "1px solid var(--hover)",
      }}
    >
      {/* Left: Market Filters */}
      <div style={{ display: "flex", gap: "10px" }}>
        {nse === 1 && statCard("NSE-FUTURE", 0, filter)}
        {nse_cash === 1 && statCard("NSE-EQUITY", 1, filter)}
        {options === 1 && statCard("NSE-OPTIONS", 2, filter)}
        {mcx === 1 && statCard("MCX-FUTURE", 3, filter)}
        {mcx_options === 1 && statCard("MCX-OPTIONS", 4, filter)}
        {comex === 1 && statCard("COMEX", 5, filter)}
        {forex === 1 && statCard("FOREX", 6, filter)}
        {crypto === 1 && statCard("CRYPTO", 7, filter)}
        {us_stock === 1 && statCard("US-STOCK", 8, filter)}
        {sgx === 1 && statCard("SGX", 9, filter)}
        {index === 1 && statCard("OTHERS", 10, filter)}
        {dgcx === 1 && statCard("DGCX", 11, filter)}
        {ncdex === 1 && statCard("NCDEX", 12, filter)}
      </div>
      {/* Right: Search */}
      <div>
        <input
          ref={searchRef}
          type="text"
          placeholder="Search Symbol"
          value={searchTerm}
          onChange={(e) => {
            setSearch(e.target.value);
            search(e.target.value);
          }}
          className="w-[180px] px-4 py-1 rounded-full text-sm focus:ring-2 outline-none"
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
          }}
        />
      </div>
    </header>
  );
}
